import { ExportFormat } from '@ecosystem/newron-client-lib';
import { createImage, createPowerPoint } from '../ExportChart';
import { getFilename } from '../ExportUtils';
import { CreateImagePowerPointParams, ExportChartArgs } from '../Model';

export const exportCombinedChart = async (args: ExportChartArgs): Promise<void> => {
  const {
    exportFn,
    exportFormats,
    invokeExport,
    title,
    appliedCountry,
    appliedPg,
    timePeriod,
    comparisonTimePeriod,
    periodType,
    showPerformanceWithin,
    appliedFiltersText,
    selectedKpi,
    pageName,
    pagesConfig,
    subtitle,
    loadedProductGroups,
  } = args;

  if (exportFormats.includes(ExportFormat.Png)) {
    const filename = getFilename({
      title,
      appliedCountry,
      appliedPg,
      timeframe: timePeriod,
      comparisonTimePeriod,
      exportFormat: ExportFormat.Png,
      selectedKpi: {
        ...selectedKpi,
        label: subtitle!,
      },
      pageName,
    });

    const methodParam: CreateImagePowerPointParams = {
      filename: filename,
      exportFn,
      appliedCountry,
      appliedPg,
      timePeriod,
      comparisonTimePeriod,
      periodType,
      showPerformanceWithin,
      appliedFiltersText,
      invokeExport,
      selectedKpi,
      pageName,
      segmentBy: '',
      title: '',
      subTitle: '',
      pagesConfig,
      loadedProductGroups,
    };

    const chartTitle = `${title} \n${subtitle}`;
    await createImage(methodParam, chartTitle);
  }

  if (exportFormats.includes(ExportFormat.Pptx)) {
    const filename = getFilename({
      title,
      appliedCountry,
      appliedPg,
      timeframe: timePeriod,
      comparisonTimePeriod,
      exportFormat: ExportFormat.Pptx,
      selectedKpi: {
        ...selectedKpi,
        label: subtitle!,
      },
      pageName,
    });

    const methodParam: CreateImagePowerPointParams = {
      filename,
      exportFn,
      appliedCountry,
      appliedPg,
      timePeriod,
      comparisonTimePeriod,
      periodType,
      showPerformanceWithin,
      appliedFiltersText,
      invokeExport,
      selectedKpi,
      pageName,
      segmentBy: '',
      title: title,
      pagesConfig,
      subTitle: subtitle!,
      loadedProductGroups,
    };

    await createPowerPoint(methodParam);
  }
};
